import React from "react";
import mission from '../Assets/mission.png'

const Mission: React.FC = () => {
    return (
        <div className="pt-20 flex px-3 md:px-40 gap-[30px]">
            <div className="flex flex-col md:w-50 justify-center">
                <h3 className="text-[18px] md:text-[29px] font-bold text-center">Our Mission</h3>
                <p className="text-[16px] md:text-[20px] text-justify">To revolutionize the justice system by providing a secure, efficient, and affordable remote court platform that empowers individuals and communities to access legal services and resolve disputes through innovative technological solutions.</p>
            </div>
            <div className="w-50 justify-end hidden md:flex"><img src={mission} alt="our vision" width='100%' /></div>
        </div>
    )
}
export default Mission